import { useNavigate } from 'react-router-dom';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-[var(--tg-theme-text-color)] mb-1.5">{title}</h3>
      <div className="text-[13px] text-[var(--tg-theme-hint-color)] leading-relaxed space-y-1.5">
        {children}
      </div>
    </div>
  );
}

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="p-4 animate-fade-in max-w-2xl mx-auto pb-24">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)} className="tg-button text-sm flex items-center gap-1.5">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Назад
        </button>
      </div>

      <div className="tg-card p-4 space-y-5">
        <div>
          <h2 className="text-lg font-bold text-[var(--tg-theme-text-color)] mb-1">📄 Условия использования EduPulse</h2>
          <p className="text-[11px] text-[var(--tg-theme-hint-color)]">Дата последнего обновления: 19 августа 2026 года</p>
          <p className="text-[12px] text-[var(--tg-theme-hint-color)] leading-relaxed mt-2">
            Настоящие Условия использования регулируют отношения между владельцем сервиса EduPulse и пользователем Telegram Mini App.
          </p>
          <p className="text-[12px] text-[var(--tg-theme-hint-color)] leading-relaxed">
            Используя EduPulse, создавая аккаунт, продолжая пользоваться сервисом или приобретая платный тариф, пользователь подтверждает согласие с настоящими Условиями.
          </p>
          <p className="text-[12px] text-[var(--tg-theme-hint-color)] leading-relaxed">
            Если пользователь не согласен с Условиями, он должен прекратить использование EduPulse.
          </p>
        </div>

        <Section title="1. Общие положения">
          <p>
            EduPulse — цифровой сервис, работающий в формате Telegram Mini App и предназначенный для преподавателей, репетиторов, кружков и образовательных организаций.
          </p>
          <p>Сервис предоставляет инструменты для:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>учёта учеников;</li>
            <li>управления курсами и группами;</li>
            <li>планирования занятий;</li>
            <li>учёта посещаемости;</li>
            <li>учёта платежей;</li>
            <li>управления достижениями;</li>
            <li>аналитики;</li>
            <li>управления командой;</li>
            <li>получения оперативных задач и уведомлений;</li>
            <li>управления подпиской.</li>
          </ul>
          <p>
            EduPulse является программным инструментом и не является образовательной организацией, юридическим, бухгалтерским или иным профессиональным консультантом.
          </p>
        </Section>

        <Section title="2. Термины">
          <p><strong>Сервис</strong> — EduPulse и связанные с ним программные компоненты.</p>
          <p><strong>Пользователь</strong> — физическое лицо, использующее EduPulse.</p>
          <p><strong>Школа</strong> — образовательная организация или рабочая команда, созданная в EduPulse.</p>
          <p><strong>Владелец школы</strong> — пользователь, которому предоставлены права управления школой.</p>
          <p><strong>Администратор</strong> — пользователь с административными правами внутри школы.</p>
          <p><strong>Преподаватель</strong> — пользователь, работающий в составе школы.</p>
          <p><strong>Системный владелец</strong> — владелец/оператор самого сервиса EduPulse.</p>
          <p><strong>Тариф</strong> — набор функций и ограничений, доступных пользователю или школе.</p>
          <p><strong>Подписка</strong> — оплаченный период доступа к платному тарифу.</p>
        </Section>

        <Section title="3. Регистрация">
          <p>
            Для использования EduPulse требуется Telegram-аккаунт. Авторизация осуществляется посредством Telegram Mini App.
          </p>
          <p>Пользователь обязан:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>предоставлять достоверные сведения;</li>
            <li>обеспечивать безопасность своего Telegram-аккаунта;</li>
            <li>не предоставлять доступ к своему аккаунту третьим лицам;</li>
            <li>не использовать чужой Telegram-аккаунт для доступа к EduPulse.</li>
          </ul>
        </Section>

        <Section title="4. Возраст и целевая аудитория">
          <p>
            EduPulse предназначен для преподавателей, репетиторов, администраторов и владельцев образовательных организаций. Сервис не предназначен для самостоятельного использования детьми.
          </p>
        </Section>

        <Section title="5. Пользовательские данные и контент">
          <p>Пользователь самостоятельно вводит в EduPulse данные учеников, родителей, курсов, групп, занятий, посещаемости, платежей, домашних заданий, заметок и достижений.</p>
          <p>
            Пользователь обязан иметь законное основание для внесения и обработки соответствующих данных. При работе с данными несовершеннолетних пользователь обязан соблюдать требования законодательства и получать необходимые согласия родителей или законных представителей.
          </p>
        </Section>

        <Section title="6. Роли">
          <p>EduPulse может предоставлять следующие роли: User, Owner School, Admin, Teacher, System Owner.</p>
          <p>Права доступа определяются ролью. Владелец школы несёт ответственность за корректное назначение ролей членам команды.</p>
        </Section>

        <Section title="7. Пользовательский контент">
          <p>
            Пользователь сохраняет права на данные и материалы, которые он законно вводит в сервис. Пользователь предоставляет EduPulse ограниченное право хранить, обрабатывать и отображать такие данные исключительно в той степени, которая необходима для предоставления сервиса.
          </p>
          <p>
            EduPulse не получает право продавать пользовательские данные или использовать их для рекламы без отдельного законного основания.
          </p>
        </Section>

        <Section title="8. Запрещённое использование">
          <p>Пользователь не вправе:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>использовать EduPulse для незаконной деятельности;</li>
            <li>получать доступ к данным других пользователей;</li>
            <li>обходить ограничения тарифа;</li>
            <li>пытаться изменить сведения о подписке через несанкционированные запросы;</li>
            <li>вмешиваться в работу серверов;</li>
            <li>осуществлять DDoS-атаки;</li>
            <li>распространять вредоносное программное обеспечение;</li>
            <li>использовать уязвимости для получения доступа к данным;</li>
            <li>осуществлять автоматизированный скрейпинг без разрешения;</li>
            <li>использовать сервис для спама;</li>
            <li>выдавать себя за другого пользователя;</li>
            <li>передавать свои права доступа третьим лицам в обход правил сервиса;</li>
            <li>использовать EduPulse способом, нарушающим права других лиц.</li>
          </ul>
        </Section>

        <Section title="9. Тарифы">
          <p>EduPulse может предоставлять несколько тарифов:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Free</strong> — бесплатный тариф с установленными ограничениями;</li>
            <li><strong>Pro</strong> — платный тариф для индивидуального преподавателя;</li>
            <li><strong>School</strong> — платный тариф для образовательной организации и команды;</li>
            <li><strong>Business</strong> — расширенный тариф, который может быть введён позднее.</li>
          </ul>
          <p>
            Конкретные функции, лимиты и стоимость отображаются непосредственно в EduPulse. Владелец сервиса вправе изменять состав тарифов, их лимиты и цены. Для уже оплаченного периода условия не изменяются задним числом.
          </p>
        </Section>

        <Section title="10. Оплата">
          <p>
            Платные цифровые функции EduPulse внутри Telegram оплачиваются через Telegram Stars. Telegram указывает, что цифровые товары и услуги в ботах и Mini Apps должны продаваться через Telegram Stars с валютным кодом XTR.
          </p>
          <p>
            Пользователь перед оплатой получает информацию о выбранном тарифе, стоимости в Stars, периоде доступа и основных условиях предоставления услуги. EduPulse не хранит данные банковской карты пользователя.
          </p>
        </Section>

        <Section title="11. Активация подписки">
          <p>
            После подтверждения успешной оплаты соответствующий тариф активируется в аккаунте пользователя или школы. Для подтверждения оплаты EduPulse может сохранять идентификатор транзакции и другие технические сведения.
          </p>
        </Section>

        <Section title="12. Trial">
          <p>
            EduPulse может предоставлять пробный период. Продолжительность и условия trial отображаются в приложении. После окончания trial доступ автоматически переводится на соответствующий бесплатный тариф.
          </p>
        </Section>

        <Section title="13. Отмена подписки">
          <p>
            Пользователь может отменить подписку в предусмотренном сервисом порядке. При отмене уже оплаченный период продолжается до даты его окончания. Отмена подписки не означает автоматическое удаление пользовательских данных.
          </p>
        </Section>

        <Section title="14. Возвраты">
          <p>
            Возвраты по платежам Telegram Stars осуществляются в соответствии с применимыми правилами Telegram и механизмами, доступными владельцу Mini App.
          </p>
          <p>Для обращений по платежам:</p>
          <p><strong>Telegram:</strong> [@username]<br /><strong>E-mail:</strong> [email]</p>
        </Section>

        <Section title="15. Изменение тарифа">
          <p>
            При переходе между тарифами условия изменения доступа отображаются пользователю перед подтверждением операции. При понижении тарифа данные пользователя не удаляются автоматически.
          </p>
        </Section>

        <Section title="16. Доступность сервиса">
          <p>
            Мы стремимся поддерживать EduPulse в рабочем состоянии, однако не гарантируем абсолютную бесперебойность, отсутствие ошибок, постоянную доступность всех функций.
          </p>
          <p>Работа сервиса может временно ограничиваться из-за технических работ, обновлений, сбоев инфраструктуры, действий Telegram, хостинг-провайдеров, обстоятельств непреодолимой силы.</p>
        </Section>

        <Section title="17. Резервное копирование">
          <p>
            Мы принимаем разумные технические меры для сохранения данных. Однако пользователь не должен рассматривать EduPulse как единственное место хранения критически важных документов.
          </p>
        </Section>

        <Section title="18. Ответственность за пользовательские данные">
          <p>Пользователь самостоятельно отвечает за законность внесения данных, достоверность данных, наличие необходимых согласий, соблюдение прав учеников и родителей, правильность отметок посещаемости, корректность сведений о платежах.</p>
        </Section>

        <Section title="19. Ограничение ответственности">
          <p>
            В пределах, разрешённых применимым законодательством, EduPulse не отвечает за решения пользователя, ошибки при вводе данные, действия с данными учеников, недоступность Telegram, сбои сторонних сервисов, потерю данных вследствие действий самого пользователя.
          </p>
        </Section>

        <Section title="20. Интеллектуальная собственность">
          <p>
            Программный код EduPulse, дизайн интерфейса, логотипы, название и иные материалы принадлежат владельцу EduPulse. Пользователь не получает право копировать, продавать или декомпилировать сервис.
          </p>
          <p>Пользователь сохраняет права на собственные данные и материалы, которые он законно загружает в сервис.</p>
        </Section>

        <Section title="21. Приостановление доступа">
          <p>
            Доступ пользователя может быть временно ограничен или прекращён при существенном нарушении Условий, попытке получить чужие данные, атаке на инфраструктуру, обходе платных ограничений, мошенничестве.
          </p>
        </Section>

        <Section title="22. Удаление аккаунта">
          <p>
            Пользователь может обратиться с запросом на удаление аккаунта. Удаление аккаунта может привести к удалению связанных данных. До удаления рекомендуется экспортировать необходимые данные.
          </p>
        </Section>

        <Section title="23. Изменение сервиса">
          <p>
            EduPulse может добавлять функции, изменять интерфейс, удалять устаревшие функции, изменять техническую архитектуру и тарифы. Существенные изменения условий доводятся до пользователей предусмотренным способом.
          </p>
        </Section>

        <Section title="24. Изменение Условий">
          <p>
            Владелец EduPulse вправе обновлять настоящие Условия. Актуальная версия публикуется в приложении. Продолжение использования сервиса после вступления новой версии означает принятие новых условий.
          </p>
        </Section>

        <Section title="25. Применимое право">
          <p>
            Настоящие Условия регулируются законодательством Республики Казахстан, если иное не предусмотрено императивными нормами применимого законодательства.
          </p>
        </Section>

        <Section title="26. Разрешение споров">
          <p>
            Стороны стремятся урегулировать спор путём обращения в службу поддержки и переговоров.
          </p>
          <p><strong>Telegram:</strong> [@username]<br /><strong>E-mail:</strong> [email]</p>
        </Section>

        <Section title="27. Контакты и поддержка">
          <p><strong>EduPulse / [ФИО или юридическое лицо]</strong></p>
          <p><strong>Telegram:</strong> [@username]<br /><strong>E-mail:</strong> [email]</p>
        </Section>

        <p className="text-[11px] text-[var(--tg-theme-hint-color)] italic pt-2 border-t border-[var(--tg-theme-section-separator-color)]">
          Важно: настоящие Условия являются рабочей версией пользовательского договора. Перед публичным коммерческим запуском необходимо проверить документ с юристом.
        </p>
      </div>
    </div>
  );
}
